/**
 * Choose which capture device Chime should bind at join. Blindly taking
 * `listAudioInputDevices()[0]` can pick a camcorder / unlabelled non-voice
 * input on Android while the default communications device is later in the
 * list — the track still reports live+unmuted, but the uplink is silence.
 */

export function pickAudioInputDeviceId(
  devices: Array<{ deviceId: string; label?: string | null }>,
): string | null {
  if (devices.length === 0) return null
  const scored = devices.map((device) => {
    const text = `${device.deviceId} ${device.label ?? ''}`.toLowerCase()
    let score = 0
    if (device.deviceId === 'default' || text.includes('default')) score += 4
    if (text.includes('communication')) score += 3
    if (text.includes('bluetooth') || text.includes('headset') || text.includes('airpod')) {
      score += 2
    }
    return { id: device.deviceId, score }
  })
  scored.sort((a, b) => b.score - a.score)
  return scored[0]?.id ?? devices[0].deviceId
}
